import { RequestWidgetData, WidgetDataError, WidgetDataLoaded } from '../actions/changelogWidget';

export default function changelogWidget(state = null, action) {
  switch (action.type) {
    case RequestWidgetData:
      return Object.assign({}, state, {
        company: { loading: true },
        error: null,
        lastUpdated: action.timestamp,
        loading: true,
        viewer: { loading: true },
      });

    case WidgetDataLoaded:
      return Object.assign({}, state, {
        company: action.result.company,
        entries: action.result.entries,
        error: null,
        hasRSSFeed: action.result.hasRSSFeed,
        labels: action.result.labels,
        lastUpdated: action.timestamp,
        loading: false,
      });

    case WidgetDataError: {
      return Object.assign({}, state, {
        error: action.error,
        lastUpdated: action.timestamp,
        loading: false,
      });
    }

    default:
      return state;
  }
}
